import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star, Zap, Timer } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-0 bg-brand-50 px-4 relative" data-id="element-167">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-gradient-to-r from-transparent via-brand-300 to-transparent" data-id="element-168" />

      <div className="max-w-6xl mx-auto" data-id="element-169">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-170">
          <h2 className="text-4xl md:text-6xl font-heading font-extrabold mb-4 text-gray-900" data-id="element-171">
            🔥 ELEGÍ TU PLAN
          </h2>
          <p className="text-xl text-gray-600" data-id="element-172">
            Acceso inmediato. Pago único. Sin suscripciones.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto items-center" data-id="element-173">
          {/* Plan Básico */}
          <motion.div className="bg-white rounded-[2.5rem] p-8 border border-gray-200 shadow-sm h-full flex flex-col" initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-174">
            <div className="mb-8" data-id="element-175">
              <h3 className="text-2xl font-heading font-bold text-gray-500 mb-2" data-id="element-176">
                📘 PLAN BÁSICO
              </h3>
              <p className="text-gray-900 font-heading font-bold text-xl mb-6" data-id="element-177">
                Mega Pack Electricidad en Casa
              </p>

              <div className="flex items-end gap-3 mb-2" data-id="element-178">
                <span className="text-gray-400 line-through text-2xl" data-id="element-179">
                  $49.990
                </span>
                <span className="text-5xl font-heading font-extrabold text-gray-900" data-id="element-180">
                  $19.990
                </span>
              </div>
              <div className="flex items-center gap-2 text-brand-500 font-bold bg-brand-50 w-fit px-3 py-1 rounded-full text-sm" data-id="element-181">
                <Timer className="w-4 h-4 animate-pulse" data-id="element-182" />
                🔥 Precio especial por tiempo limitado
              </div>
            </div>

            <div className="space-y-4 mb-8 flex-grow" data-id="element-183">
              <p className="font-bold text-gray-900 mb-4" data-id="element-184">Incluye:</p>
              {['Tomo 1 — Electricidad básica', 'Tomo 2 — Enchufes y tomacorrientes', 'Tomo 3 — Llaves de luz y lámparas', 'Tomo 4 — Problemas eléctricos', 'Tomo 5 — Instalaciones eléctricas', 'Tomo 6 — Seguridad y mantenimiento', 'Bono 1 — Guía rápida de fallas', 'Bono 2 — Herramientas eléctricas', 'Bono 3 — Planos eléctricos básicos'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-185">
                  <div className="bg-brand-50 rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-186">
                    <Check className="w-4 h-4 text-brand-500" data-id="element-187" />
                  </div>
                  <span className="text-gray-600 font-medium" data-id="element-188">{item}</span>
                </div>)}
            </div>

            <div className="pt-6 border-t border-gray-100 space-y-4" data-id="element-189">
              <div className="flex justify-center gap-4 text-sm text-gray-500 font-medium mb-4" data-id="element-190">
                <span className="flex items-center gap-1" data-id="element-191">
                  <Zap className="w-4 h-4" data-id="element-192" /> Acceso inmediato
                </span>
                <span className="flex items-center gap-1" data-id="element-193">📄 Todo en PDF</span>
              </div>
              <a href="https://checkoutpuntoebook.store/checkouts/cn/hWNAXwzkko7cwLCltDPzSV3y/es-ar?_r=AQABo8bkBHvJoTf8atjBsiAdSo-sDy9QemyAnn-MRPOyujc&cart_link_id=rP5273A8&preview_theme_id=159224365312" target="_blank" rel="noopener noreferrer" className="block w-full py-4 px-6 bg-white border-2 border-brand-500 hover:bg-brand-50 text-brand-600 font-bold text-center rounded-2xl transition-colors text-lg" data-id="element-194">
                → QUIERO EL PLAN BÁSICO
              </a>
            </div>
          </motion.div>

          {/* Plan Premium */}
          <motion.div className="bg-gradient-to-b from-brand-400 to-brand-600 rounded-[2.5rem] p-1.5 relative transform lg:-translate-y-4 shadow-[0_20px_50px_rgba(236,72,153,0.3)] h-full flex flex-col" initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-195">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-gray-900 text-white px-6 py-1.5 rounded-full font-bold text-sm flex items-center gap-2 whitespace-nowrap shadow-lg" data-id="element-196">
              <Star className="w-4 h-4 fill-brand-400 text-brand-400" data-id="element-197" />
              El más elegido
            </div>

            <div className="bg-white rounded-[2.25rem] p-8 h-full flex flex-col relative overflow-hidden" data-id="element-198">
              <div className="absolute top-0 right-0 w-32 h-32 bg-brand-50 rounded-bl-full -mr-4 -mt-4 opacity-50" data-id="element-199" />

              <div className="mb-8 relative z-10" data-id="element-200">
                <h3 className="text-2xl font-heading font-bold text-brand-600 mb-2" data-id="element-201">
                  🏆 PLAN PREMIUM
                </h3>
                <p className="text-gray-900 font-heading font-bold text-xl mb-6" data-id="element-202">
                  Mega Pack Electricidad en Casa PRO
                </p>

                <div className="flex items-end gap-3 mb-2" data-id="element-203">
                  <span className="text-gray-400 line-through text-2xl" data-id="element-204">
                    $89.990
                  </span>
                  <span className="text-5xl font-heading font-extrabold text-gray-900" data-id="element-205">
                    $29.990
                  </span>
                </div>
                <div className="flex items-center gap-2 text-brand-500 font-bold bg-brand-50 w-fit px-3 py-1 rounded-full text-sm" data-id="element-206">
                  <Timer className="w-4 h-4 animate-pulse" data-id="element-207" />
                  🔥 Precio especial por tiempo limitado
                </div>
              </div>

              <div className="space-y-4 mb-8 flex-grow relative z-10" data-id="element-208">
                <p className="font-bold text-gray-900 mb-4" data-id="element-209">
                  Incluye{' '}
                  <span className="text-brand-600 bg-brand-50 px-2 py-0.5 rounded" data-id="element-210">
                    TODO el Plan Básico
                  </span>{' '}
                  más contenido extra:
                </p>
                {['Guía rápida de soluciones eléctricas en casa', 'Checklist de mantenimiento del hogar', 'Organización de mantenimiento del hogar', 'Diagramas eléctricos del hogar', 'Resumen paso a paso de instalaciones comunes'].map((item, i) => <div key={i} className="flex items-start gap-3 bg-brand-50/50 p-3 rounded-xl border border-brand-100" data-id="element-211">
                    <div className="bg-brand-100 rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-212">
                      <Check className="w-4 h-4 text-brand-600" data-id="element-213" />
                    </div>
                    <span className="text-gray-800 font-semibold" data-id="element-214">{item}</span>
                  </div>)}
              </div>

              <div className="pt-6 border-t border-gray-100 space-y-4 relative z-10" data-id="element-215">
                <div className="flex justify-center gap-4 text-sm text-gray-500 font-medium mb-4" data-id="element-216">
                  <span className="flex items-center gap-1" data-id="element-217">
                    <Zap className="w-4 h-4 text-brand-500" data-id="element-218" /> Acceso inmediato
                  </span>
                  <span className="flex items-center gap-1" data-id="element-219">
                    📄 Todo en PDF
                  </span>
                </div>
                <a href="https://checkoutpuntoebook.store/checkouts/cn/hWNAXvtMyFyJABWvNvVwI882/es-ar?_r=AQABJfuwWy44nilbbNaD5MjZ79Aw7vgqSXD8tTaNl4CbfUc&cart_link_id=f1T9l8Ds&preview_theme_id=159224365312" target="_blank" rel="noopener noreferrer" className="block w-full py-4 px-6 bg-brand-500 hover:bg-brand-600 text-white font-bold text-center rounded-2xl transition-all transform hover:scale-105 shadow-[0_8px_20px_rgba(236,72,153,0.3)] text-lg" data-id="element-220">
                  → QUIERO EL PLAN PREMIUM
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}